import React, { Component, PropTypes } from 'react';
import RulerBar from 'components/RulerBar';
import moment from 'moment';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import DiscountStore from 'stores/Discount';
import DiscountActions from 'actions/Discount';
import {
  Toolbar,
  ToolbarGroup,
  ToolbarTitle,
  FontIcon,
  Dialog,
  FlatButton,
  List,
  RaisedButton,
  TextField,
  Toggle,
  DatePicker,
  RadioButtonGroup,
  RadioButton,
  ListItem
} from 'material-ui';
import { GridCell, GridContainer } from 'components/Grid';
import { FormattedMessage, FormattedDate } from 'react-intl';
import Config from 'Config';
import Message from 'services/Message';
import * as SvgIcons from 'components/Material/SvgIcons';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import ScrollableContainer from 'components/ScrollableContainer';
import SimpleOverview from 'components/Widgets/SimpleOverview';
import CourseActions from 'actions/Course';
import SelectableList from 'components/Widgets/SelectableList';
import DialogPortal from 'components/DialogPortal';
import CourseSelector from 'components/CourseSelector';
import BundleSelector from 'components/BundleSelector';

let {
  ImageImage,
  EditorModeEdit,
  ContentAdd,
  ActionDelete,
  ActionLabel,
  ContentSave,
  ContentClear,
  ContentCreate
} = SvgIcons;

export default class DiscountForm extends Component {
  constructor() {
    super(...arguments);
    const { discount } = this.props;
  }

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {
    editing: false
  };

  // listenToStores() {
  //   this.listenToStore(DiscountStore, 'discount');
  // }

  listenToActions() {
    this.listenToAction(DiscountActions.removeComplete, discount => {
      Message.info(this.context.getIntlMessage('discount.removed'));
      this.refs.confirmDialog.dismiss();
      this.props.onClose();
    });

    this.listenToAction(DiscountActions.removeError, errorMessage => {
      this.onError(errorMessage);
      this.refs.confirmDialog.dismiss();
    });
  }

  closeDetail() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  copyToClipboard(e) {
    const copyEvent = new ClipboardEvent('copy');
    copyEvent.clipboardData.setData(
      'text/plain',
      Config.discountHost + '/' + this.state.discount.discount.pseudoId
    );
    copyEvent.preventDefault();
    document.dispatchEvent(copyEvent);

    Message.info(this.context.getIntlMessage('Copied'));
  }

  confirmDelete(discount) {
    DiscountActions.remove(discount);
    this.refs.confirmDialog.dismiss();
    this.closeDetail();
  }

  deleteDiscount() {
    this.refs.confirmDialog.show();
  }

  addCourses() {
    CourseActions.filter();
    this.refs.addCoursesDialog.show();
  }

  selectCourse(selectedObjects) {
    this.props.discount.objects = Object.keys(selectedObjects).map(objectId => {
      return { id: objectId, name: selectedObjects[objectId] };
    });
    this.setState({ discount: this.props.discount });
  }

  closeCourseSelection() {
    const objects = Object.keys(this.refs.courseSelector.getSelected()).map(
      id => {
        return { type: 1, id: parseInt(id, 10) };
      }
    );

    const packages = Object.keys(this.refs.bundelSelector.getSelected()).map(
      id => {
        return { type: 2, id: parseInt(id, 10) };
      }
    );

    packages.forEach(item => {
      objects.push(item);
    });

    // let objects = this.props.discount.objects.map(object => {
    //   return parseInt(object.id, 10);
    // });
    DiscountActions.update(parseInt(this.props.discount.id, 10), { objects });
    this.refs.addCoursesDialog.dismiss();
  }

  setStartDate = (foo, startDate) => {
    DiscountActions.update(this.props.discount.id, { startDate });
  };

  setEndDate = (foo, endDate) => {
    DiscountActions.update(this.props.discount.id, { endDate });
  };

  setValue(ev) {
    let discount = parseFloat(this.refs.discount.getValue());
    if (!discount || typeof discount !== 'number') {
      DiscountActions.update(this.props.discount.id, { discount: 1 });
    } else {
      DiscountActions.update(this.props.discount.id, {
        discount: parseFloat(ev.target.discount) || 0
      });
    }
  }

  setMaxCount(ev) {
    const maxCount = parseFloat(ev.target.value) || 0;
    DiscountActions.update(this.props.discount.id, { maxCount });
  }

  setDiscountType = (event, value) => {
    const type = parseInt(value, 10) || 0;
    DiscountActions.update(this.props.discount.id, { type });
  };

  onChangeActive = (event, active) => {
    DiscountActions.update(this.props.discount.id, { active });
  };

  autoSave = () => {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
    const code = this.refs.code.getValue();
    const active = this.refs.active.isToggled();
    const discount = parseFloat(this.refs.discount.getValue());
    const maxCount = parseInt(this.refs.maxCount.getValue(), 10);
    const type = parseInt(this.refs.type.getSelectedValue(), 10);
    if (code.length <= 30) {
      this._timer = setTimeout(() => {
        DiscountActions.update(this.props.discount.id, {
          code,
          discount,
          active,
          maxCount,
          type,
          startDate: this.refs.startDate.getDate(),
          endDate: active ? this.refs.endDate.getDate() : null
        });
      }, 1000);
      this.closeEdit();
    } else {
      Message.info(this.context.getIntlMessage('discount.codeRestriction'));
    }
  };

  openEdit = () => {
    this.setState({ editing: true });
  };

  closeEdit = () => {
    this.setState({ editing: false });
  };

  deleteObject = object => {
   const objects = this.props.discount.objects.filter(obj => {
      return !(object.type === obj.type && object.id === obj.id);
    });
    DiscountActions.update(parseInt(this.props.discount.id, 10), { objects });
  };

  render() {
    const { discount } = this.props;
    const discountedPackages = discount.objects.filter( item => parseInt(item.type,10) === 2 )
    const discountedCourses = discount.objects.filter( item => parseInt(item.type,10) === 1 )

    let start, end;
    if (discount.startDate === '0000-00-00 00:00:00') {
      start = new Date();
    } else {
      start = new Date(discount.startDate);
    }

    if (discount.endDate === '0000-00-00 00:00:00') {
      end = new Date() + 30;
    } else {
      end = new Date(discount.endDate);
    }

    let objects = discount.objects || [];

    let courseActions = [
      <FlatButton
        key="ok"
        label={this.context.getIntlMessage('OK')}
        secondary={true}
        className="full"
        onTouchTap={this.closeCourseSelection.bind(this)}
      />
    ];
    let confirmActions = [
      { text: 'Cancel' },
      {
        text: 'Submit',
        onTouchTap: this.confirmDelete.bind(this, discount),
        ref: 'submit'
      }
    ];
    if (this.state.editing) {
      let toolbar = (
        <Toolbar>
          <ToolbarGroup float={'left'} key={0}>
            <ToolbarTitle
              text={this.context.getIntlMessage('discount.discount')}
            />
          </ToolbarGroup>
          <ToolbarGroup float={'right'} key={1}>
            <ToolbarIconButton
              svgIcon={<ContentSave />}
              onTouchTap={this.autoSave.bind(this)}
              tooltip={this.context.getIntlMessage('Save')}
            />
            <ToolbarIconButton
              svgIcon={<ContentClear />}
              onTouchTap={this.closeEdit.bind(this)}
              tooltip={this.context.getIntlMessage('Cancel')}
            />
          </ToolbarGroup>
        </Toolbar>
      );

      return (
        <ScrollableContainer header={toolbar}>
          <GridContainer fluid style={{ padding: 20 }}>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.code')}
              <br />
              <TextField ref="code" defaultValue={discount.code} type="text" />
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.amount')}
              <br />
              <TextField
                ref="discount"
                defaultValue={discount.discount}
                onChange={this.setValue.bind(this)}
                type="float"
              />
            </GridCell>
            <GridCell size={12} xSmallSize={12}>
              <RadioButtonGroup
                ref="type"
                name={this.context.getIntlMessage('discount.type')}
                valueSelected={discount.type + ''}
                style={{ padding: '1.5em 0' }}
                onChange={this.setDiscountType}
              >
                <RadioButton
                  value={'2'}
                  label={this.context.getIntlMessage('discount.typeAbsolute')}
                />
                <RadioButton
                  value={'1'}
                  label={this.context.getIntlMessage('discount.typePercentage')}
                />
              </RadioButtonGroup>
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.Start')}
              <br />
              <DatePicker
                ref="startDate"
                onChange={this.setStartDate.bind(this)}
                value={start}
                hintText={this.context.getIntlMessage('discount.Start')}
              />
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.End')}
              <br />
              <DatePicker
                ref="endDate"
                onChange={this.setEndDate.bind(this)}
                value={end}
                hintText={this.context.getIntlMessage('discount.End')}
              />
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.limitedUse')}
              <br />
              <TextField
                ref="maxCount"
                defaultValue={
                  discount.maxCount == null ? '0' : discount.maxCount
                }
                onChange={this.setMaxCount.bind(this)}
                type="float"
              />
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              <br />
              <FormattedMessage
                message={this.context.getIntlMessage('discount.used')}
                count={discount.count || '0'}
                maxCount={discount.maxCount || '0'}
              />
            </GridCell>
            <GridCell size={12} xSmallSize={12}>
              {this.context.getIntlMessage('discount.active')}
              <br />
              <Toggle
                ref="active"
                toggled={discount.active}
                onToggle={this.onChangeActive}
                style={{ marginTop: '10px' }}
              />
            </GridCell>
          </GridContainer>

          <DialogPortal>
            <Dialog
              ref="addCoursesDialog"
              // title={<h3 className='mui-dialog-title'>{this.context.getIntlMessage('Choose Courses')}</h3>}
              title={this.context.getIntlMessage('course.choose')}
              actions={courseActions}
              autoDetectWindowHeight={true}
              autoScrollBodyContent={true}
              dismissOnClickAway={true}
            >
              <CourseSelector
                ref="courseSelector"
                selected={discount.objects}
              />
            </Dialog>

            <Dialog
              ref="confirmDialog"
              title={this.context.getIntlMessage('discount.remove')}
              actions={confirmActions}
              actionFocus="submit"
              dismissOnClickAway={true}
            >
              <FormattedMessage
                message={this.context.getIntlMessage('discount.removeDiscount')}
                discount={discount.code}
              />
            </Dialog>
          </DialogPortal>
        </ScrollableContainer>
      );
    } else {
      let toolbar = (
        <Toolbar>
          <ToolbarGroup float={'left'} key={0}>
            <ToolbarTitle text={this.context.getIntlMessage('Discount')} />
          </ToolbarGroup>
          <ToolbarGroup float={'right'} key={1}>
            <ToolbarIconButton
              svgIcon={<ContentCreate />}
              onTouchTap={this.openEdit.bind(this)}
              tooltip={this.context.getIntlMessage('Create')}
            />
            <ToolbarIconButton
              svgIcon={<ContentAdd />}
              onTouchTap={this.addCourses.bind(this)}
              tooltip={this.context.getIntlMessage('Add')}
            />
            <ToolbarIconButton
              svgIcon={<ActionDelete />}
              onTouchTap={this.deleteDiscount.bind(this)}
              tooltip={this.context.getIntlMessage('Delete')}
            />
            <ToolbarIconButton
              svgIcon={<ContentClear />}
              onTouchTap={this.closeDetail.bind(this)}
              tooltip={this.context.getIntlMessage('Clear')}
            />
          </ToolbarGroup>
        </Toolbar>
      );

      return (
        <ScrollableContainer header={toolbar}>
          <GridContainer fluid style={{ padding: 20 }}>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.code')}
              <br />
              <List>
                <ListItem primaryText={discount.code} disabled />
              </List>
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.amount')}
              <br />
              <List>
                <ListItem primaryText={discount.discount} disabled />
              </List>
            </GridCell>
            <GridCell size={12} xSmallSize={12}>
              {this.context.getIntlMessage('discount.type')}
              <br />
              <List>
                <ListItem
                  disabled
                  primaryText={
                    discount.type + '' == '2'
                      ? this.context.getIntlMessage('discount.typeAbsolute')
                      : this.context.getIntlMessage('discount.typePercentage')
                  }
                />
              </List>
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.Start')}
              <br />
              <DatePicker
                style={{pointerEvents: 'none'}}
                ref="startDate"
                onChange={this.setStartDate.bind(this)}
                value={start}
                hintText={this.context.getIntlMessage('discount.Start')}
              />
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.End')}
              <br />
              <DatePicker
                style={{pointerEvents: 'none'}}
                ref="endDate"
                onChange={this.setEndDate.bind(this)}
                value={end}
                hintText={this.context.getIntlMessage('discount.End')}
              />
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              {this.context.getIntlMessage('discount.limitedUse')}
              <br />
              <List>
                <ListItem
                  primaryText={
                    discount.maxCount == null ? '0' : discount.maxCount
                  }
                  disabled
                />
              </List>
            </GridCell>
            <GridCell size={6} xSmallSize={6}>
              <br />
              <FormattedMessage
                message={this.context.getIntlMessage('discount.used')}
                count={discount.count || '0'}
                maxCount={discount.maxCount || '∞'}
              />
            </GridCell>
            <GridCell size={12} xSmallSize={12}>
              {this.context.getIntlMessage('discount.active')}
              <br />
              <Toggle
                ref="active"
                toggled={discount.active}
                style={{ marginTop: '10px' }}
              />
            </GridCell>
          </GridContainer>

          <SimpleOverview
            items={discountedCourses}
            readable="name"
            title={this.context.getIntlMessage('discount.affectedObjects')}
            onTouchTapRightIcon={this.deleteObject}
          />
           <SimpleOverview
            items={discountedPackages}
            readable="name"
            title={this.context.getIntlMessage('discount.affectedPackages')}
            onTouchTapRightIcon={this.deleteObject}
          />
          <DialogPortal>
            <Dialog
              ref="addCoursesDialog"
              // title={<h3 className='mui-dialog-title'>{this.context.getIntlMessage('Choose Courses')}</h3>}
              title={this.context.getIntlMessage('course.choose')}
              actions={courseActions}
              autoDetectWindowHeight={true}
              autoScrollBodyContent={true}
              dismissOnClickAway={true}
            >
              <CourseSelector
                ref="courseSelector"
                selected={discount.objects.filter( item => parseInt(item.type,10) === 1 )}
              />
              <h3 style={{ marginTop: '10px', fontSize: '24px', lineHight: '32px' }}>Välj paket</h3>
              <BundleSelector
                ref="bundelSelector"
                selected={discount.objects.filter( item => parseInt(item.type,10) === 2 )}
              />
            </Dialog>

            <Dialog
              ref="confirmDialog"
              title={this.context.getIntlMessage('discount.remove')}
              actions={confirmActions}
              actionFocus="submit"
              dismissOnClickAway={true}
            >
              <FormattedMessage
                message={this.context.getIntlMessage('discount.removeDiscount')}
                discount={discount.code}
              />
            </Dialog>
          </DialogPortal>
        </ScrollableContainer>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Discount/Detail.js